import { fromJS } from 'immutable';

export default fromJS({
    programTypes: []
});
